import HeaderComponent from "../../components/headerComponent/HeaderComponent";
import HeaderContComponent from "../../components/headerContactComponent/HeaderContComponent";
import { Carousel } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import "./HomePageStyle.css";
import { db, whatsappLink } from "../../config/FirebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import FooterComponent from "../../components/footerComponent/FooterComponent";
import Loader from "../../components/loader/Loader";
// import { httpsCallable } from "firebase/functions";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import FloatingNotification from "../../components/FloatingNotification/FloatingNotification";
import AppPromotionSection from "../../components/home/AppDownload";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

export default function HomePage() {
  const [index, setIndex] = useState(0);
  const [panel1, setPanel1] = useState([]);
  const [panel2, setPanel2] = useState([]);
  const [panel3, setPanel3] = useState([]);
  const [panel4, setPanel4] = useState([]);
  const [carousel, setCarousel] = useState([]);
  const [isLoading, setLoading] = useState(false);

  // Create refs for animation targets
  const carouselRef = useRef(null);
  const plansTitleRef = useRef(null);
  const plansCardsRef = useRef(null);
  const lancamentosTitleRef = useRef(null);
  const lancamentosCardsRef = useRef(null);
  const vantagensTitleRef = useRef(null);
  const vantagensCardsRef = useRef(null);
  const bgElementsRef = useRef([]);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    setLoading(true);
    handleAccess();

    const getPanels = async () => {
      const data = await getDocs(collection(db, "panels"));
      setPanel1(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 1)
      );
      setPanel2(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 2)
      );
      setPanel3(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 3)
      );
      setPanel4(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 4)
      );
    };

    const getCarousel = async () => {
      const carouselCollection = collection(db, "carousel");
      const data = await getDocs(carouselCollection);
      const carouselData = data.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setCarousel(carouselData);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    };

    getPanels();
    getCarousel();
  }, []);

  useEffect(() => {
    if (!isLoading && carousel.length > 0) {
      initAnimations();
    }
  }, [isLoading, carousel]);

  const initAnimations = () => {
    // Carousel entrance animation
    gsap.from(carouselRef.current, {
      opacity: 0,
      y: 50,
      duration: 1,
      ease: "sine.inOut",
    });

    // Plans section animations
    gsap.from(plansTitleRef.current, {
      scrollTrigger: {
        trigger: plansTitleRef.current,
        start: "top 85%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 30,
      duration: 0.8,
      ease: "power2.out",
    });

    gsap.from(plansCardsRef.current.children, {
      scrollTrigger: {
        trigger: plansCardsRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 50,
      duration: 0.6,
      stagger: 0.1,
      ease: "back.out",
    });

    // Lançamentos section animations
    gsap.from(lancamentosTitleRef.current, {
      scrollTrigger: {
        trigger: lancamentosTitleRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 30,
      duration: 0.8,
      ease: "power2.out",
    });

    gsap.from(lancamentosCardsRef.current.children, {
      scrollTrigger: {
        trigger: lancamentosCardsRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 50,
      duration: 0.6,
      stagger: 0.1,
      ease: "back.out",
    });

    // Vantagens section animations
    gsap.from(vantagensTitleRef.current, {
      scrollTrigger: {
        trigger: vantagensTitleRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 30,
      duration: 0.8,
      ease: "power2.out",
    });

    gsap.from(vantagensCardsRef.current.children, {
      scrollTrigger: {
        trigger: vantagensCardsRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 50,
      duration: 0.6,
      stagger: 0.15,
      ease: "back.out",
    });

    // Background elements animation
    gsap.from(bgElementsRef.current, {
      scrollTrigger: {
        trigger: ".content",
        start: "top center",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 30,
      duration: 1,
      stagger: 0.2,
      ease: "sine.out",
    });

    // Card hover animations
    const cards = document.querySelectorAll(".plan-card, .plan-card-vantagens");
    cards.forEach((card) => {
      card.addEventListener("mouseenter", () => {
        gsap.to(card, {
          scale: 1.03,
          duration: 0.3,
          ease: "power2.out",
        });
      });
      card.addEventListener("mouseleave", () => {
        gsap.to(card, {
          scale: 1,
          duration: 0.3,
          ease: "power2.out",
        });
      });
    });
  };

  async function handlePanelClick(card) {
    setLoading(true);
    try {
      // const setCardClickCount = httpsCallable(functions, "setCardClickCount");
      // await setCardClickCount({ panel: card.panel, card: card.card });
    } catch (error) {
      console.error("Error tracking card click:", error);
    } finally {
      setLoading(false);
    }
    return Promise.resolve();
  }

  async function handleAccess() {
    try {
      // const setCardClickCount = httpsCallable(functions, "setCountClick");
      // await setCardClickCount();
    } catch (error) {
      console.error("Error tracking access:", error);
    }
    return Promise.resolve();
  }

  // Add background elements to ref array
  const addToBgElementsRef = (el) => {
    if (el && !bgElementsRef.current.includes(el)) {
      bgElementsRef.current.push(el);
    }
  };

  return (
    <div>
      {isLoading && <Loader />}
      <HeaderContComponent />
      <HeaderComponent />

      {/* Carousel with ref */}
      <div ref={carouselRef}>
        <Carousel
          style={{ marginTop: 50, backgroundColor: "#0a0a0a", width: "100%" }}
          activeIndex={index}
          onSelect={handleSelect}
        >
          {carousel.map((banner) => (
            <Carousel.Item
              key={banner.id}
              interval={7000}
              onClick={() => banner.link && window.open(banner.link, "_blank")}
              style={{ cursor: banner.link ? "pointer" : "default" }}
            >
              <img
                alt=""
                src={banner.photo}
                // src={
                //   "https://placehold.co/2000x540/0a0a0a/ffffff?text=Teste+Banner+2000x540"
                // }
                className="responsive-image desktop"
              />
              <img
                alt=""
                src={banner.photoMobile}
                // src={
                //   "https://placehold.co/200x200/0a0a0a/ffffff?text=Teste+Banner+200x200"
                // }
                className="responsive-image mobile"
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      <div className="content">
        <div className="content-sub">
          {/* Plans Section */}
          <div id="plans" className="plan-container">
            <div ref={plansTitleRef} className="plan-title">
              PLANOS <span className="plan-highlight">EXTRAORDINÁRIOS</span>{" "}
              PARA VOCÊ
            </div>
            <div className="retangle-line"></div>
            <div ref={plansCardsRef} className="plan-cards">
              {panel1.map((card) => (
                <span
                  key={card.id}
                  className="plan-card"
                  onClick={() => {
                    handlePanelClick(card).then(
                      () => (window.location.href = `${whatsappLink}`)
                    );
                  }}
                >
                  <img alt="" src={card.photo} className="panel-card-img" />
                </span>
              ))}
            </div>
          </div>

          {/* Lançamentos Section */}
          <div id="lancamentos" className="plan-container">
            <div ref={lancamentosTitleRef} className="plan-title">
              CONFIRA <span className="plan-highlight">SUPERLANÇAMENTOS</span>{" "}
              AQUI
            </div>
            <div className="retangle-line"></div>
            <div ref={lancamentosCardsRef} className="plan-cards">
              {panel2.map((card) => (
                <span
                  key={card.id}
                  className="plan-card"
                  onClick={() => {
                    handlePanelClick(card).then(
                      () => (window.location.href = `${whatsappLink}`)
                    );
                  }}
                >
                  <img alt="" src={card.photo} className="panel-card-img" />
                </span>
              ))}
            </div>
          </div>

          {/* Vantagens Section */}
          <div id="advantage" className="plan-container">
            <div ref={vantagensTitleRef} className="plan-title">
              NOSSAS{" "}
            </div>
            <div ref={vantagensTitleRef} className="plan-title">
              <span className="plan-highlight2">VANTAGENS</span>
            </div>
            <div className="retangle-line2"></div>
            <div ref={vantagensCardsRef} className="plan-cards">
              {panel3.map((card) => (
                <span key={card.id} className="plan-card-vantagens">
                  <img alt="" src={card.photo} className="panel-card-img" />
                </span>
              ))}
            </div>
          </div>
          <div id="app">
            <AppPromotionSection />
          </div>
          <FooterComponent />
          <FloatingNotification />
        </div>
      </div>
      {/* Background elements with refs */}
      <div ref={addToBgElementsRef} className="bg-1"></div>
      <div ref={addToBgElementsRef} className="bg-2"></div>
      <div ref={addToBgElementsRef} className="bg-3"></div>
      <div ref={addToBgElementsRef} className="bg-4"></div>
      <div ref={addToBgElementsRef} className="bg-5"></div>
    </div>
  );
}
